// import React from 'react';
// import MadeWithLove from './MadeWithLove';

// const About = (props) => {
//     const aboutUsStyles = {
//         backgroundColor: props.mode === "primary" ? 'white' : "#484747",
//         padding: '50px 0',
//         color: props.mode === "primary" ? "black" : "white"
//     };

//     const contentStyles = {
//         maxWidth: '800px',
//         margin: '0 auto',
//         textAlign: 'center',
//     };

//     const headingStyles = {
//         fontSize: '23px',
//         marginBottom: '20px',
//     };

//     const paragraphStyles = {
//         fontSize: '17px',
//         lineHeight: '1.6',
//     };
//     return (
//         <div>
//             <div style={aboutUsStyles}>
//                 <div style={contentStyles}>
//                     <h2 style={headingStyles}>Introducing "NewsyDoozy" - Embark on a Journey of Engaging Discoveries!</h2>
//                     <p style={paragraphStyles}>Welcome to NewsyDoozy, your ultimate gateway to a captivating realm of information and insight. Our name, carefully crafted to evoke a sense of fascination and intrigue, captures the essence of what we stand for - a continuous quest for the most riveting and noteworthy stories from across the globe.</p>
//                     <p style={paragraphStyles}>At NewsyDoozy, we believe that staying informed is more than just a habit; it's a rewarding experience. In a world brimming with news sources, we serve as your compass, guiding you through the vast landscape of information to uncover stories that truly matter. Our mission is simple yet profound: to curate and present news that sparks your curiosity, broadens your horizons, and empowers you to make informed decisions.</p>
//                     <p style={paragraphStyles}>The NewsyDoozy Difference:</p>
//                     <ul>
//                         <li style={paragraphStyles}>Diverse Topics: Dive into a kaleidoscope of subjects, from the latest developments in business, entertainment, and technology, to the cutting-edge frontiers of science, health, sports, and beyond. Our meticulously curated sections ensure you find news that resonates with your interests.</li>
//                         <li style={paragraphStyles}>Easy Navigation: Seamlessly navigate our site with our intuitive navbar. Whether you're seeking the pulse of the business world or the thrill of the sports arena, our dedicated sections provide a shortcut to the stories you're most passionate about.</li>
//                         <li style={paragraphStyles}>Unleash the Buzz - For Free: Accessing quality news should never come at a cost. NewsyDoozy is proud to offer an entirely free platform, ensuring that everyone can unlock the doors to knowledge without barriers. We believe in democratizing information, and we're committed to empowering minds, one headline at a time.</li>
//                         <li style={paragraphStyles}>Engaging Design: Just as news stories captivate your attention, our website's design captivates your senses. With a harmonious blend of aesthetics and functionality, NewsyDoozy provides an immersive experience that encourages you to explore, learn, and share.</li>
//                     </ul>
//                     <p style={paragraphStyles}>Join us on this journey of exploration, empowerment, and enlightenment. Let NewsyDoozy be your trusted companion, your source of inspiration, and your window to the world. Together, let's unravel the stories that shape our lives and leave an indelible mark on our understanding of the world around us.</p>
//                     <p style={paragraphStyles}>Are you ready to "Unleash the Buzz"? Stay informed, stay curious, and let NewsyDoozy be your guiding star.</p>
//                 </div>
//             </div>
//             <div className="my-3" style={{
//                 fontSize: "20px",
//                 color: "#fff",
//                 textAlign: "center",
//                 padding: "10px",
//                 bottom: "10px",
//                 backgroundColor: "#333",
//                 zIndex: "9999",
//                 margin: "auto",
//                 left: "0",
//                 right: "0"
//             }}>
//                 <MadeWithLove mode={props.mode} />
//             </div>
//         </div>
//     )
// }

// export default About

import React from 'react';
import MadeWithLove from './MadeWithLove';

const About = (props) => {
    const isDarkMode = props.mode === 'dark';
    const aboutContainerStyle = {
        padding: '20px',
        background: isDarkMode ? '#484747' : '#f8f8f8',
        borderRadius: '8px',
        boxShadow: `0px 4px 8px ${isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
    };

    const sectionStyle = {
        marginBottom: '20px',
        padding: '20px',
        background: isDarkMode ? '#2d2d2d' : 'white',
        borderRadius: '8px',
        boxShadow: `0px 2px 4px ${isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
    };

    const textStyle = {
        color: isDarkMode ? 'white' : 'black',
    };

    return (
        <div>
            <div className="container my-3" style={aboutContainerStyle}>
                <section style={sectionStyle}>
                    <h2 style={textStyle}>Introducing "NewsyDoozy" - Embark on a Journey of Engaging Discoveries!</h2>
                    <p style={textStyle}>Welcome to NewsyDoozy, your ultimate gateway to a captivating realm of information and insight. Our name, carefully crafted to evoke a sense of fascination and intrigue, captures the essence of what we stand for - a continuous quest for the most riveting and noteworthy stories from across the globe.</p>
                    <p style={textStyle}>At NewsyDoozy, we believe that staying informed is more than just a habit; it's a rewarding experience. In a world brimming with news sources, we serve as your compass, guiding you through the vast landscape of information to uncover stories that truly matter. Our mission is simple yet profound: to curate and present news that sparks your curiosity, broadens your horizons, and empowers you to make informed decisions.</p>
                    <p style={textStyle}>The NewsyDoozy Difference:</p>
                    <ul>
                        <li style={textStyle}>Diverse Topics: Dive into a kaleidoscope of subjects, from the latest developments in business, entertainment, and technology, to the cutting-edge frontiers of science, health, sports, and beyond. Our meticulously curated sections ensure you find news that resonates with your interests.</li>
                        <li style={textStyle}>Easy Navigation: Seamlessly navigate our site with our intuitive navbar. Whether you're seeking the pulse of the business world or the thrill of the sports arena, our dedicated sections provide a shortcut to the stories you're most passionate about.</li>
                        <li style={textStyle}>Unleash the Buzz - For Free: Accessing quality news should never come at a cost. NewsyDoozy is proud to offer an entirely free platform, ensuring that everyone can unlock the doors to knowledge without barriers. We believe in democratizing information, and we're committed to empowering minds, one headline at a time.</li>
                        <li style={textStyle}>Engaging Design: Just as news stories captivate your attention, our website's design captivates your senses. With a harmonious blend of aesthetics and functionality, NewsyDoozy provides an immersive experience that encourages you to explore, learn, and share.</li>
                    </ul>
                    <p style={textStyle}>Join us on this journey of exploration, empowerment, and enlightenment. Let NewsyDoozy be your trusted companion, your source of inspiration, and your window to the world. Together, let's unravel the stories that shape our lives and leave an indelible mark on our understanding of the world around us.</p>
                    <p style={textStyle}>Are you ready to "Unleash the Buzz"? Stay informed, stay curious, and let NewsyDoozy be your guiding star.</p>
                </section>
            </div>
            <div className="my-3" style={{
                fontSize: "20px",
                color: "#fff",
                textAlign: "center",
                padding: "10px",
                bottom: "10px",
                backgroundColor: "#333",
                zIndex: "9999",
                margin: "auto",
                left: "0",
                right: "0"
            }}>
                <MadeWithLove mode={props.mode} />
            </div>
        </div>
    )
}

export default About

